import React from "react";
import AbstractPage from "./AbstractPage";

class Home extends AbstractPage {
  constructor(props) {
    super(props)

    this.title = "Anglo iForm";
  }

  render() {
    return (
      <div className="layout-content" />
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js